<template>
    <div class="container mx-auto px-3 pb-64 2xl:px-0" :class="size">
        <slot></slot>
    </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    maxSize: {
        type: String,
        default: 'xl',
    },
});

const size = computed(() => {
    switch (props.maxSize) {
        case '2xl':
            return 'max-w-(--breakpoint-2xl)';
        default:
            return 'max-w-(--breakpoint-xl)';
    }
});
</script>
